class Search {
  constructor(buttonSelector, searchContainer, navigation) {
    this.isOpen = false;
    this.nav = navigation;
    this.buttonOpen = document.querySelector(buttonSelector+'.open');
    this.buttonClose = document.querySelector(buttonSelector+'.close');
    this.searchContainer = document.querySelector(searchContainer);

    this.initListeners();
    this.nav.initSearch(this);
  }

  initListeners() {
    if (!this.buttonOpen || !this.buttonClose || !this.searchContainer) {
      return;
    }

    this.buttonOpen.addEventListener('click', () => {
      this.open()
    })

    this.buttonClose.addEventListener('click', () => {
      this.close()
    })


  }

  open() {
    this.searchContainer.classList.add('open');
    this.isOpen = true;
    if (this.nav.isOpen) {
      this.nav.closeMenu();
    }
    document.body.classList.add('search-open');
  }

  close() {
    this.searchContainer.classList.remove('open')
    this.isOpen = false;
    document.body.classList.remove('search-open')
  }
}

export default Search;



// WEBPACK FOOTER //
// ./scripts/libs/Search.js